const places = [
  {
    title: "Green",
    description:
      "The Maldives are home to some of the world's most ravishing islands, but it's the sea, which truly makes these islands shine. Luminous aquamarine waters with a crystal clarity lap upon these dazzling white shores, which barely peek above the Indian Ocean.",
    time: 1500,
    imageUrl: "POK",
  },
  {
    title: "Bora Bora",
    description:
      "Shaped like a giant sombrero, this lush volcanic island stars in countless South Pacific fantasies. The focal point and best asset of this tropical beauty is its ravishing lagoon in technicolor turquoise. Fish, turtles, sharks, and rays swim in the clear waters.",
    time: 1500,
    imageUrl: "",
  },
];

export default places;
